import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submitForm(event) {
    event.preventDefault()
    
    const form = event.target
    const submitButton = form.querySelector('[type="submit"]')
    const jobId = form.dataset.jobId
    const role = form.querySelector('#role').value
    const initialView = form.querySelector('#initial_view').value
    const password = form.querySelector('#password').value
    
    
    // Desabilitar botão durante request
    const originalText = submitButton.textContent
    submitButton.disabled = true
    submitButton.textContent = 'Gerando...'

    // Fazer requisição
    fetch(`/ats/company/jobs/${jobId}/shared_links`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        ats_job_shared_link: {
          role: role,
          initial_view: initialView,
          password: password
        }
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.json()
    })
    .then(data => {
      if (data.success) {
        this.handleSuccess(data)
        form.reset() // Limpar formulário
      } else {
        this.handleError(data)
      }
      // Reabilitar botão
      submitButton.disabled = false
      submitButton.textContent = originalText
    })
    .catch(error => {
      console.error('Fetch error:', error)
      this.handleError({ errors: ['Erro ao conectar com o servidor. Verifique sua conexão e tente novamente.'] })
      submitButton.disabled = false
      submitButton.textContent = originalText
    })
  }

  handleSuccess(data) {
    if (data.success) {
      // Mostrar feedback com o link gerado
      const feedbackDiv = document.getElementById('link-generation-feedback')
      // Escapar valores para uso seguro em HTML
      const escapedJobTitle = this.escapeHtml(data.job_title || '')
      const escapedUrl = this.escapeHtml(data.url || '')
      const escapedPassword = this.escapeHtml(data.password || '')
      const initialViewLabel = this.escapeHtml(data.initial_view_humanized || 'Etapas')
      const initialViewBadgeClass = this.escapeHtml(data.initial_view_badge_class || 'bg-primary')
      
      feedbackDiv.innerHTML = `
        <div class="alert alert-success alert-dismissible fade show" role="alert">
          <h6 class="alert-heading">
            <i class="fas fa-check-circle me-2"></i>
            Link gerado com sucesso!
          </h6>
          <p class="mb-2"><strong>Papel:</strong> ${data.role_humanized}</p>
          <p class="mb-2">
            <strong>Visualização:</strong>
            <span class="badge ${initialViewBadgeClass} ms-1">${initialViewLabel}</span>
          </p>
          <p class="mb-2"><strong>Expira em:</strong> ${data.expires_at}</p>
          <div class="input-group mt-2">
            <input type="text" 
                   class="form-control" 
                   value="${escapedUrl}" 
                   readonly 
                   id="generated-link-url">
            <button class="btn btn-outline-primary copy-feedback-btn" 
                    type="button"
                    data-job-title="${escapedJobTitle}"
                    data-url="${escapedUrl}"
                    data-password="${escapedPassword}">
              <i class="fas fa-copy"></i> Copiar
            </button>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
      `
      
      // Adicionar event listener ao botão de copiar do feedback
      const copyFeedbackBtn = feedbackDiv.querySelector('.copy-feedback-btn')
      if (copyFeedbackBtn) {
        copyFeedbackBtn.addEventListener('click', (e) => {
          e.preventDefault()
          const btn = e.currentTarget
          const jobTitle = btn.dataset.jobTitle || ''
          const url = btn.dataset.url || ''
          const password = btn.dataset.password || ''
          
          let textToCopy
          if (password && password.trim() !== '') {
            if (jobTitle && jobTitle.trim() !== '') {
              textToCopy = `Acesse a vaga ${jobTitle} na plataforma HunterHero.\nLink para a vaga: ${url}\nSenha de acesso: ${password}`
            } else {
              textToCopy = `Acesse a vaga na plataforma HunterHero.\nLink para a vaga: ${url}\nSenha de acesso: ${password}`
            }
          } else {
            textToCopy = url
          }
          
          navigator.clipboard.writeText(textToCopy).then(() => {
            const originalHTML = btn.innerHTML
            btn.innerHTML = '<i class="fas fa-check"></i> Copiado!'
            setTimeout(() => {
              btn.innerHTML = originalHTML
            }, 2000)
          }).catch(err => {
            alert('Erro ao copiar link. Por favor, copie manualmente.')
            console.error('Failed to copy:', err)
          })
        })
      }

      // Limpar form
      const form = document.getElementById('new-shared-link-form')
      if (form) form.reset()

      // Adicionar novo link diretamente na lista
      this.addLinkToList(data)
    }
  }

  addLinkToList(data) {
    const existingLinksSection = document.querySelector('.existing-links-section')
    if (!existingLinksSection) {
      console.error('existingLinksSection NOT FOUND!')
      return
    }

    // Atualizar contador
    const badge = existingLinksSection.querySelector('.badge')
    const currentCount = parseInt(badge.textContent) || 0
    badge.textContent = currentCount + 1

    // Verificar se existe a lista de links ou se precisa criar
    let linksList = existingLinksSection.querySelector('.links-list')
    const alertInfo = existingLinksSection.querySelector('.alert-info')

    // Se existe o alerta de "nenhum link", remover e criar a lista
    if (alertInfo) {
      alertInfo.remove()
      linksList = document.createElement('div')
      linksList.className = 'links-list'
      existingLinksSection.appendChild(linksList)
    }

    // Criar o HTML do novo link
    const linkCard = document.createElement('div')
    linkCard.className = 'card mb-3'
    linkCard.setAttribute('data-link-id', data.id)
    linkCard.innerHTML = `
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-start">
          <div class="flex-grow-1">
            <h6 class="card-title mb-2">
              <i class="fas fa-user-tag me-2"></i>
              ${data.role_humanized}
              <span class="badge ${data.initial_view_badge_class || 'bg-primary'} ms-2">
                ${data.initial_view_humanized || 'Etapas'}
              </span>
            </h6>
            
            <p class="card-text small mb-2">
              <i class="fas fa-user me-1"></i>
              Criado por <strong>${data.created_by_name}</strong>
              em ${data.created_at}
            </p>
            
            <p class="card-text small mb-2">
              <span class="badge bg-success">
                <i class="fas fa-check-circle me-1"></i>
                Ativo até ${data.expires_at}
              </span>
              <span class="badge bg-info ms-2">
                ${data.access_count} ${data.access_count === 1 ? 'acesso' : 'acessos'}
              </span>
            </p>
          </div>
          
          <div class="d-flex flex-column gap-2 ms-3">
            <button 
              class="btn btn-sm btn-outline-primary copy-link-btn"
              data-url="${data.url}"
              data-password="${data.password || ''}"
              data-job-title="${data.job_title || ''}"
              data-role="${data.role_humanized || ''}"
              data-action="click->shared-link-form#copyLink"
              title="Copiar link e senha">
              <i class="fas fa-copy me-1"></i> Copiar Link
            </button>
            
            <button 
              class="btn btn-sm btn-outline-danger expire-link-btn"
              data-link-id="${data.id}"
              data-job-id="${data.job_id}"
              data-action="click->shared-link-form#expireLink"
              title="Expirar link">
              <i class="fas fa-ban me-1"></i> Expirar
            </button>
          </div>
        </div>
      </div>
    `

    // Adicionar no topo da lista
    linksList.insertBefore(linkCard, linksList.firstChild)
  }

  handleError(data) {
    const feedbackDiv = document.getElementById('link-generation-feedback')
    const errors = data.errors ? data.errors.join('<br>') : 'Erro ao gerar link'
    
    feedbackDiv.innerHTML = `
      <div class="alert alert-danger alert-dismissible fade show" role="alert">
        <i class="fas fa-exclamation-triangle me-2"></i>
        ${errors}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
    `
  }

  copyLink(event) {
    event.preventDefault()
    const button = event.currentTarget
    const url = button.dataset.url
    let password = button.dataset.password
    const jobTitle = button.dataset.jobTitle || ''
    const role = button.dataset.role || ''

    // Usar role como descrição se disponível, senão usar jobTitle
    const description = role || jobTitle || 'a vaga'
    
    // Se não tiver senha, pedir ao usuário
    if (!password || password.trim() === '') {
      password = prompt(`Informe a senha de acesso para o link da vaga "${description}":`)
      if (!password || password.trim() === '') {
        // Usuário cancelou ou não informou senha
        return
      }
    }

    // Sempre copiar no formato com descrição da vaga e senha
    const textToCopy = `Acesse a vaga ${description} na plataforma HunterHero.\nLink para a vaga: ${url}\nSenha de acesso: ${password}`

    navigator.clipboard.writeText(textToCopy).then(() => {
      // Feedback visual
      const originalHTML = button.innerHTML
      button.innerHTML = '<i class="fas fa-check me-1"></i> Copiado!'
      button.classList.remove('btn-outline-primary')
      button.classList.add('btn-success')

      setTimeout(() => {
        button.innerHTML = originalHTML
        button.classList.remove('btn-success')
        button.classList.add('btn-outline-primary')
      }, 2000)
    }).catch(err => {
      alert('Erro ao copiar link. Por favor, copie manualmente.')
      console.error('Failed to copy:', err)
    })
  }

  expireLink(event) {
    event.preventDefault()
    
    if (!confirm('Tem certeza que deseja expirar este link?\n\nEsta ação não pode ser desfeita e o link não poderá mais ser usado.')) {
      return
    }

    const button = event.currentTarget
    const linkId = button.dataset.linkId
    const jobId = button.dataset.jobId

    // Desabilitar botão durante request
    button.disabled = true
    button.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Expirando...'

    fetch(`/ats/company/jobs/${jobId}/shared_links/${linkId}/expire`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          throw new Error(err.error || `HTTP error! status: ${response.status}`)
        }).catch(() => {
          throw new Error(`HTTP error! status: ${response.status}`)
        })
      }
      return response.json()
    })
    .then(data => {
      if (data.success) {
        const linkCard = document.querySelector(`[data-link-id="${linkId}"]`)
        if (linkCard) {
          
          // Remover o card da lista
          linkCard.remove()
          
          // Atualizar contador de links
          const existingLinksSection = document.querySelector('.existing-links-section')
          if (existingLinksSection) {
            const linksList = existingLinksSection.querySelector('.links-list')
            const badge = existingLinksSection.querySelector('.badge')
            
            if (linksList) {
              const remainingLinks = linksList.querySelectorAll('.card').length
              if (badge) {
                badge.textContent = remainingLinks
              }
              
              // Se não houver mais links, mostrar mensagem
              if (remainingLinks === 0) {
                linksList.remove()
                existingLinksSection.innerHTML = `
                  <div class="alert alert-info">
                    <i class="fas fa-info-circle me-2"></i>
                    Nenhum link de compartilhamento foi gerado ainda.
                  </div>
                `
              }
            }
          }
          
        }
      } else {
        console.error('❌ Failed to expire link:', data)
        alert('Erro ao expirar link: ' + (data.error || 'Erro desconhecido'))
        button.disabled = false
        button.innerHTML = '<i class="fas fa-ban me-1"></i> Expirar'
      }
    })
    .catch(error => {
      console.error('❌ Error expiring link:', error)
      alert('Erro ao expirar link. Tente novamente.')
      button.disabled = false
      button.innerHTML = '<i class="fas fa-ban me-1"></i> Expirar'
    })
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
